<script lang="ts" setup>
const { $api } = useNuxtApp()

import searchJobBg from '@images/illustration/search-job-bg.png'

const route = useRoute()
const { t } = useI18n()
const provinces = ref([])
const locations = ref([])
const isLoading = ref(false)
const search = ref(route.query.search)

const emit = defineEmits(['set-filter'])

const isClearSearch = defineModel({ type: Boolean })

const filter = ref({
    search: route.query.search || undefined ,
    province_id: Number(route.query.province_id) || undefined,
})

const { data: locationsData } = await $api.master.getLocations()
locations.value = locationsData.value.data

const getProvince = async (id: any) => {
    const { data: provinceData } = await $api.master.getProvinces({
        query: { country_id: id }
    })
    provinces.value = provinceData.value.data
}
//Get Indonesia province data with country_id 1
getProvince(1)

// onMounted(() => {
//     nextTick(async () => {
//         filter.value = {
//             search: route.query.search || null,
//             location_id: Number(route.query.location_id) || null
//         }
//     })
// })

watch(
    filter,
    (val) => {
        if (!isClearSearch.value) {
            emit('set-filter', val)
        } else {
            isClearSearch.value = false
        }
    },
    { deep: true }
)

watch(isClearSearch, (val) => {
    if (val) {
        filter.value.search = undefined
        filter.value.province_id = undefined
    }
})

const updateSearch = () => {
    // If search.value is null or undefined, default to an empty string
    filter.value.search = search.value ?? ''
}

const searchJob = () => {
    if (search.value) {
        updateSearch()
    } else {
        emit('set-filter', filter.value)
    }
}
</script>

<template>
    <h1 class="d-sr-only">Samurai Recruitment All Job</h1>
    <VSkeletonLoader v-if="isLoading" type="image"></VSkeletonLoader>
    <div
        v-else
        class="search__container py-8 py-md-10"
        :style="{
            backgroundImage: `url(${searchJobBg})`
        }"
    >
        <VContainer>
            <VRow class="justify-center gap-3" no-gutters>
                <VCol cols="12" sm="3" md="3" lg="2">
                    <VAutocomplete
                        :placeholder="t('Province')"
                        v-model="filter.province_id"
                        :items="provinces"
                        item-value="id"
                        item-title="name"
                        bg-color="surface"
                        density="compact"
                        prepend-inner-icon="ri-map-pin-line"
                        clearable
                    ></VAutocomplete>
                </VCol>
                <VCol cols="12" sm="6" md="7" lg="7">
                    <VTextField
                        v-model="search"
                        :placeholder="t('search_by_keywords')"
                        density="compact"
                        bg-color="surface"
                        clearable
                        @click:clear="updateSearch"
                        @keydown.enter.prevent="updateSearch"
                    />
                </VCol>
                <VCol cols="12" sm="2" md="1" lg="1">
                    <VBtn color="error" @click="searchJob" block>
                        {{ t('search') }}
                    </VBtn>
                </VCol>
            </VRow>
        </VContainer>
    </div>
</template>

<style lang="scss" scoped>
.search__container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgb(var(--v-theme-pure-white));
    text-align: center;
    background-size: cover;
    background-position: left;
    margin-bottom: 24px;
    border-radius: 10px;
}
</style>
